export const SETTINGS_PATH_VOCABULARY_ROOT = '/manage-vocabulary' as const;
export const SETTINGS_ZOOM_CONNECTION_ROOT =
  '/zoom-connection-settings' as const;

import { getDesktopAppUtmContent } from '@otter-ai/desktop/utils';
export const SETTINGS_PATHS = {
  SETTINGS_GENERAL: '/setting',
  SETTINGS_INTEGRATIONS: '/setting/connected_apps',
  SETTINGS_SLACK: '/setting/connected_apps/slack',
  SETTINGS_NOTIFICATIONS: '/setting/notifications',
  SETTINGS_SECURITY: '/setting/security',
  SETTINGS_MEETINGS: '/setting/share-notes',
  SETTINGS_PLAN: '/setting/plan',
  SETTINGS_PLANS: '/setting/plans',
  SETTINGS_PERSONAL_TEMPLATES: '/setting/personal-templates',
  SETTINGS_PERSONAL_TEMPLATES_BUILDER:
    '/setting/personal-templates/personal-template-builder',
  SETTINGS_DEVELOPER: '/setting/developer',

  SETTINGS_VOCABULARY_BASIC_INDEX: `${SETTINGS_PATH_VOCABULARY_ROOT}/basic`,
  SETTINGS_VOCABULARY_ADVANCED_INDEX: SETTINGS_PATH_VOCABULARY_ROOT,
  SETTINGS_VOCABULARY_ADVANCED_TEAM_NAMES: `${SETTINGS_PATH_VOCABULARY_ROOT}/team/names`,
  SETTINGS_VOCABULARY_ADVANCED_TEAM_OTHER: `${SETTINGS_PATH_VOCABULARY_ROOT}/team/other`,
  SETTINGS_VOCABULARY_ADVANCED_PERSONAL_NAMES:
    '/manage-vocabulary/personal/names',
  SETTINGS_VOCABULARY_ADVANCED_PERSONAL_OTHER:
    '/manage-vocabulary/personal/other',

  SETTINGS_ZOOM_CONNECTION: SETTINGS_ZOOM_CONNECTION_ROOT,
  SETTINGS_ZOOM_CONNECTION_CLOUD_SYNC: `${SETTINGS_ZOOM_CONNECTION_ROOT}/cloud-sync`,
  SETTINGS_ZOOM_CONNECTION_LIVE_NOTES: `${SETTINGS_ZOOM_CONNECTION_ROOT}/live-notes`,
  SETTINGS_ZOOM_CONNECTION_WEBINAR: `${SETTINGS_ZOOM_CONNECTION_ROOT}/live-notes/webinar`,
} as const;

export const ONBOARDING_PATHS = {
  WELCOME: 'welcome',
} as const;

export const PATH_URL = {
  PRO: 'pro',
  TEAM: 'team',
  HOME: 'home',
  TWITTER_CARD: 'twitter_card',
  CONVERSATION_PAGE: 'u',
  MEETING_URL: 'mt',
  LOGIN: 'login',
  SIGNUP: 'signup',
  SIGNIN: 'signin',
  OAUTH_CALLBACK: 'callback',
  FORWARD: 'forward',
  PURCHASE_PAGE: 'purchase',
  PURCHASE_PRO_PLAN: '/purchase/pro',
  PURCHASE_TEAM_PLAN: '/purchase/team',
  PASSWORD: 'password',
  FORGOT_PASSWORD: 'forgot-password',
  RESET: 'reset',
  CONFIRM_PASSWORD_RESET: 'confirm',
  SETUP_PROFILE: 'setup-profile',
  TWO_FACTOR: 'two-factor',
  TWO_FACTOR_SETUP: 'two-factor-setup',
  SSO_LOGIN: 'sso-login',
  EMAIL_VERIFY: 'email-verify',
  CONFIRM_EMAIL: 'confirm',
  VERIFY_CHANGE_EMAIL: 'verify/change_email',
  INVITE: 'invite',
  INVITING: '/inviting',
  TUTORIALS: '/tutorials',
  JOIN_TEAM_WARNING: 'join-team-warning',
  OTTER_CHAT: 'otter-chat',
  SHARE_SNIPPET: 's',
  RECORDING: 'recording',

  MANAGE_TEAM: '/manage-team',
  TEAM_TEMPLATES: '/manage-team/templates',
  TEAM_PROFILE: '/manage-team/team-profile',
  TEAM_TEMPLATE_BUILDER: '/manage-team/templates/workspace-template-builder',

  ZOOM_ONBOARDING: '/zoom-onboarding',
  ZOOM_CLOUD_SYNC_CONNECTION_SETTINGS: '/zoom-connection-settings/cloud-sync',
  ZOOM_LIVE_NOTES_CONNECTION_SETTINGS: '/zoom-connection-settings/live-notes',
  ...SETTINGS_PATHS,
  ...ONBOARDING_PATHS,
} as const;

const utmContent = encodeURIComponent(getDesktopAppUtmContent());
export const PURCHASE_UPGRADE_URLS = {
  ZOOM_MORE_INTEGRATION_UPGRADE: `/purchase/team?zoom_compliance=true&utm_content=${utmContent}`,
  VOCABULARY_UPGRADE: `/purchase/pro?vocab=true&utm_content=${utmContent}`,
};

export const EXPLORE_URL = 'explore';
